export const ComplianceLabels = {
  Ticker: 'Ticker',
  Cusip: 'cusip',
  Isin: 'isin',
  Currency: 'Currency',
  Instrument: 'Instrument',
} as const
